import React, { useEffect, useState } from "react";
import apiClient from "../apiClient";
import { toast } from "react-toastify";

const PendingTransferPopup = ({ shopId, shopName }) => {
  const [pendingTransfers, setPendingTransfers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [visible, setVisible] = useState(true);
  const [expandedId, setExpandedId] = useState(null);
  const [productDetails, setProductDetails] = useState({});

  const fetchPendingTransfers = async () => {
    try {
      setLoading(true);
      const res = await apiClient.post("/Liquor/GetPendingTransfers", {
        shopId: Number(shopId),
      });
      if (res.data?.data?.length > 0) {
        setPendingTransfers(res.data.data);
        setVisible(true);
      } else {
        setVisible(false);
      }
    } catch (err) {
      console.error("PendingTransfer fetch error:", err);
      toast.error("Failed to load pending transfers");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (shopId) fetchPendingTransfers();
  }, [shopId]);

  const toggleProducts = async (transferId) => {
    if (expandedId === transferId) {
      setExpandedId(null);
      return;
    }
    setExpandedId(transferId);
    if (productDetails[transferId]) return;
    try {
      const res = await apiClient.post("/Liquor/GetStgTransferProducts", { transferId });
      setProductDetails((prev) => ({ ...prev, [transferId]: res.data?.data || [] }));
    } catch {
      setProductDetails((prev) => ({ ...prev, [transferId]: [] }));
    }
  };

  const handleApproveReject = async (transferId, isApproved) => {
    try {
      setLoading(true);
      await apiClient.post("/Liquor/ApproveRejectTransfer", {
        transferId,
        action: isApproved ? "Approve" : "Reject",
      });
      toast.success(isApproved ? "Transfer Approved Successfully" : "Transfer Rejected Successfully");
      const updated = pendingTransfers.filter((x) => x.transferId !== transferId);
      setPendingTransfers(updated);
      if (updated.length === 0) setVisible(false);
    } catch {
      toast.error("Failed to process transfer");
    } finally {
      setLoading(false);
    }
  };

  if (!visible || !pendingTransfers.length) return null;

  return (
    <div className="pending-popup d-flex align-items-center justify-content-center">
      <div className="pending-card">

        {/* Header */}
        <div className="pending-header">
          <div>
            <h5 className="pending-title">Pending Transfers</h5>
            <span className="pending-badge">{pendingTransfers.length} Pending</span>
          </div>
          <button className="pending-close-btn" onClick={() => setVisible(false)}>✕</button>
        </div>

        {/* Body */}
        <div className="pending-body">
          {pendingTransfers.map((item) => (
            <div key={item.transferId} className="pending-item">

              {/* Shop Name */}
              <div className="pending-shop-row">
                <span className="pending-label">From Shop</span>
                <span className="pending-shop-name">{item.receiverShopName || item.shopName}</span>
              </div>

              {/* Transaction & Invoice */}
              <div className="pending-info-grid">
                <div className="pending-info-cell">
                  <span className="pending-label">Transaction</span>
                  <span className="pending-value-highlight">{item.transactionNumber}</span>
                </div>
               
              </div>

              {/* Remark */}
              <div className="pending-remark-row">
                <span className="pending-label">Remark</span>
                <span className="pending-remark-text">{item.remark || "—"}</span>
              </div>

              {/* Product Toggle */}
              <button
                className="pending-toggle-btn"
                onClick={() => toggleProducts(item.transferId)}
              >
                {expandedId === item.transferId ? "▲ Hide Products" : "▼ View Products"}
              </button>

              {expandedId === item.transferId && (
                <div className="pending-products-wrap">
                  {!productDetails[item.transferId] ? (
                    <div className="pending-loading">Loading...</div>
                  ) : productDetails[item.transferId].length === 0 ? (
                    <div className="pending-loading">No product details found</div>
                  ) : (
                    <table className="pending-product-table">
                      <thead>
                        <tr>
                          <th>Product</th>
                          <th>Packing</th>
                        </tr>
                      </thead>
                      <tbody>
                        {productDetails[item.transferId].map((p, i) => (
                          <tr key={i}>
                            <td>{p.productName || p.pName || p.name}</td>
                            <td>{p.variant || "—"}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  )}
                </div>
              )}

              {/* Actions */}
              <div className="pending-actions">
                <button
                  className="btn-approve"
                  disabled={loading}
                  onClick={() => handleApproveReject(item.transferId, true)}
                >
                  ✓ Approve
                </button>
                <button
                  className="btn-reject"
                  disabled={loading}
                  onClick={() => handleApproveReject(item.transferId, false)}
                >
                  ✗ Reject
                </button>
              </div>

            </div>
          ))}
        </div>

      </div>
    </div>
  );
};

export default PendingTransferPopup;
